






















import { Component, Prop, Mixins } from "vue-property-decorator";

// Mixins
import RequestPromises from "@/mixins/requestPromises";
import ProvisioningMixin from "@/mixins/provisioningMixin";

// Types
import { IProduct } from "@/models/products";
import { OrgConfigKeys } from "@/data/constants";

@Component({
  components: {
    "edit-product-provisioning": () =>
      import(
        "@/components/app/admin/catalogue/products/provisioning/editProductProvisioning.vue"
      )
  }
})
export default class ProductProvisioningView extends Mixins(
  RequestPromises,
  ProvisioningMixin
) {
  // Props
  @Prop({ required: true })
  public productId!: IProduct["id"];

  // Data
  public isLoading = true;
  public isReloading = false;
  public requestError = false;

  public async created() {
    this.loadData();
  }

  public async loadData() {
    try {
      await this.getOrgProvisioning(this.isReloading);
      if (!this.$store.getters["org/hasProvisioningEnabled"]) {
        this.$router.push({
          name: "adminCatalogueProductDetails",
          params: { productId: this.productId.toString() }
        });
      }
      this.getAllProvisionConfigurations();
      this.requestError = false;
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
      this.requestError = true;
    } finally {
      this.isLoading = false;
      this.isReloading = false;
    }
  }

  public reloadData() {
    this.isReloading = true;
    this.loadData();
  }

  public getOrgProvisioning(ignoreStored = false) {
    return this.$store.dispatch("org/getConfig", {
      ignoreStored,
      keys: [OrgConfigKeys.PRODUCT_PROVISIONING_ENABLED]
    });
  }

  public get i18n() {
    return {
      title: this.$t("_.provisioning")
    };
  }
}
